/**
 * Layout route for /offers/$offerId
 *
 * Acts as a transparent layout wrapper so child routes (workspace index and
 * version snapshot) can render independently. All workspace content lives in
 * $offerId/index.tsx; the snapshot lives in $offerId.versions.$versionId.tsx.
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/offers/$offerId')({
  component: () => <Outlet />,
});
